import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { Subject, takeUntil } from 'rxjs';
import { LoadingService } from './services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private authService: AuthService,
    private loadingService: LoadingService,
    private cdref: ChangeDetectorRef
  ) {}

  isLoading = false;
  private destroy = new Subject<boolean>();

  ngOnInit(): void {
    this.authService.autoSignIn();
    this.loadingService.isLoading.pipe(takeUntil(this.destroy)).subscribe({
      next: (status: boolean) => {
        this.isLoading = status;
        this.cdref.detectChanges();
      },
    });
  }

  ngOnDestroy(): void {
    this.destroy.next(true);
    this.destroy.complete();
  }
}
